import { PumpMotoLogPagination } from '@/module/pump_moto_log/domain/model/pump_moto_log_pagination';
import { en } from '@/module/pump_moto_log/domain/model/pump_moto_log';
import { PumpMotoLogPaginationParams, FetchPumpMotoLogRepository } from '@/module/pump_moto_log/data/repository/fetch_pump_moto_log_repository';

type FetchPumpMotoLogParams = {
  placeID: number
  startDate?: string
  endDate?: string
  page: number
  itemsPerPage?: number
}

export interface FetchPumpMotoLogUseCase {
    (params: FetchPumpMotoLogParams): Promise<PumpMotoLogPagination>
}

const fetchPumpMotoLogUseCase = (repository: FetchPumpMotoLogRepository): FetchPumpMotoLogUseCase => async (params: FetchPumpMotoLogParams) => {
  const { placeID, page, itemsPerPage, startDate, endDate } = params
  try {
    const payload: PumpMotoLogPaginationParams = {
      sort: en.created_date,
      descending: "false",
      page,
      itemsPerPage: itemsPerPage ?? 10,
      startDate,
      endDate,
      placeID
    }
    return await repository(payload);
  } catch (error) {
    throw error
  }
}

export default fetchPumpMotoLogUseCase;
